import * as types from '../types/diary';

export const DiaryDetailState: types.DiaryDetailState = {
  item: null,
  detailError: null,
  isDetailFetching: false,
};
